import { USE_CASES } from "../data/site";
import { Reveal } from "./Reveal";

export const UseCases = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8" data-testid="usecases-grid">
    {USE_CASES.map((c, i) => (
      <Reveal key={c.title} delay={i * 0.1}>
        <article
          data-testid={`usecase-card-${i}`}
          className="h-full overflow-hidden rounded-3xl bg-white border border-[#8A9B87]/15 shadow-[0_8px_30px_rgb(0,0,0,0.03)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
        >
          <img
            src={c.image}
            alt={c.alt}
            loading="lazy"
            decoding="async"
            className="h-52 w-full object-cover"
          />
          <div className="p-7 sm:p-8">
            <h3 className="text-xl sm:text-2xl font-medium text-[#2E2E2C]">{c.title}</h3>
            <p className="mt-3 text-base text-[#2E2E2C]/70 leading-relaxed">{c.text}</p>
          </div>
        </article>
      </Reveal>
    ))}
  </div>
);
